import React, { useState } from 'react'
import { formatDate, ROUTES } from '../../shared/constants'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useQuery, useQueryClient } from 'react-query'
import { deleteDocumentById, getAllData } from '../../lib/RestApi/customApiHandler'
import useDebounce from '../../hooks/useDebounce'

export default function BusinessType() {
  const [searchQuery, setSearchQuery] = useState('')
  const debouncedValue = useDebounce(searchQuery, 500)
  let { data: businessTypes, isLoading } = useQuery(['business-type', debouncedValue && debouncedValue], () => getAllData('/business-type', { searchQuery: debouncedValue }))

  const queryClient = useQueryClient()

  let tmpArr = []
  if (!isLoading && businessTypes?.data?.length > 0) {
    businessTypes.data.map((item) => {
      return tmpArr.push([{ type: 'CHECKBOX', _id: item._id }, { value: item.name }, { value: formatDate(item.createdAt) }])
    })
  }

  const layoutProps = {
    heading: 'Manage Business Type',
    url: ROUTES.ADD_BUSINESS_TYPE,
    editUrl: 'edit-business-type/',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    // tempHeaders: tempHeaders,
    // tempHeaderData: [],
    // filename: 'moduleAdmins',
    // sampleName: 'sample_moduleAdmins',
    // sheetName: 'moduleAdmin',
    // headers: pdfCsvData.headings,
    // data: pdfCsvData.headingValues,
    // downloadLoading,
  }

  const deleteMany = async (ids) => {
    for await (let id of ids) {
      deleteDocumentById('/business-type', id)
    }
    queryClient.invalidateQueries('business-type')
  }

  return (
    <CustomTableLayout
      tableHeadings={['Business Type Name', 'Created At']}
      loading={isLoading}
      tableBody={tmpArr}
      // handleSwitchChange={handleSwitchChange}
      // handlePageChange={handleChange}
      // paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => {
        deleteMany(val)
        setSelected([])
      }}
    />
  )
}
